import PlanFactReportDashboardContainer from './containers/PlanFactReportDashboardContainer';

export default PlanFactReportDashboardContainer;
